export const routes = {
  signup: '/register',
  signin: '/login',
  home: '/',
  info: '/info',
  events: '/events',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
}
